export default __webpack_public_path__ + "static/media/Heart.0bb1c29c.svg";